<template>
  <div class="page-content">
    <div class="content-view">
      <div class="page-title">Distributions of Members</div>
      <div class="text" v-if="false">
        A National Federation of UNESCO Clubs, Centres and Associations, (having
        minimum three UNESCO Clubs, Centres and Associations in that country as
        members) with recommendation of the National Commission for UNESCO of
        that country can apply for the membership of WFUCA. The membership is
        approved by the World Congress of WFUCA on recommendation of its
        Executive Board.
      </div>
      <div id="world" style="width: 100%; height: 600px"></div>
      <div
        class="content-menu"
        style="margin: 30px 0 !important"
        v-if="this.$store.state.webType == 'h5'"
      >
        <div class="menu-item" @click="handleMenuClick('Types')">
          <div class="item-icon">
            <img src="@/assets/images/ship/ship-icon01.png" />
          </div>
          <div class="item-title">Membership Types</div>
        </div>
        <div class="menu-item" @click="handleMenuClick('Rights')">
          <div class="item-icon">
            <img src="@/assets/images/ship/ship-icon02.png" />
          </div>
          <div class="item-title">Membership Rights and Obligations</div>
        </div>
        <div class="menu-item" @click="handleMenuClick('Become')">
          <div class="item-icon">
            <img src="@/assets/images/ship/ship-icon03.png" />
          </div>
          <div class="item-title">How to Become Member</div>
        </div>
      </div>
      <div class="world-view">
        <div class="world-title">
          Membership List <span>Sorted Alphabetically</span>
        </div>
        <div class="sub-title one">Full Members</div>
        <div class="world-items">
          <div
            class="item full"
            @click="handleFullDetail(item)"
            v-for="(item, index) in memberList1"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="sub-title">Associate Member</div>
        <div class="world-items">
          <div class="item" v-for="(item, index) in memberList2" :key="index">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="content-menu" v-if="this.$store.state.webType !== 'h5'">
      <div class="menu-item" @click="handleMenuClick('Types')">
        <div class="item-icon">
          <img src="@/assets/images/ship/ship-icon01.png" />
        </div>
        <div class="item-title">Membership <br />Types</div>
      </div>
      <div class="menu-item" @click="handleMenuClick('Rights')">
        <div class="item-icon">
          <img src="@/assets/images/ship/ship-icon02.png" />
        </div>
        <div class="item-title">
          Rights and<br />
          Duties of<br />
          Members
          <!-- Membership <br />Rights and <br />
          Obligations -->
        </div>
      </div>
      <div class="menu-item" @click="handleMenuClick('Become')">
        <div class="item-icon">
          <img src="@/assets/images/ship/ship-icon03.png" />
        </div>
        <div class="item-title">
          How to Become <br />
          Member
        </div>
      </div>
    </div>

    <el-dialog
      class="full-dialog"
      title=""
      :visible.sync="detailVisible"
      width="65%"
      :before-close="handleClose"
    >
      <div class="detail-title">{{ fullInfo.name }}</div>
      <div class="detail-view">
        <div class="detail-item">
          <div class="label">Full name:</div>
          <div class="content">{{ fullInfo.fullName }}</div>
        </div>
        <div class="detail-item">
          <div class="label">Year of establishment:</div>
          <div class="content">{{ fullInfo.establishment }}</div>
        </div>
        <div class="detail-item">
          <div class="label">Year of admission to WFUCA:</div>
          <div class="content">{{ fullInfo.admission }}</div>
        </div>
        <div class="detail-item">
          <div class="label">President:</div>
          <div class="content">{{ fullInfo.president }}</div>
        </div>
        <div class="detail-item">
          <div class="label">Secretary-General:</div>
          <div class="content">{{ fullInfo.general }}</div>
        </div>
        <div class="detail-item">
          <div class="label">Contact:</div>
          <div class="content">{{ fullInfo.contact }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as echarts from "echarts";
import world from "../../assets/world.js";
export default {
  name: "MembersIntroduct",
  components: {},
  data() {
    return {
      myChart: "",
      worldList: [],
      memberList1: [],
      memberList2: [],
      detailVisible: false,
      fullInfo: {},
    };
  },
  created() {},
  mounted() {
    // console.log(echarts);
    this.$get(`${this.$api}/un/webpart/plat`, {}).then((res) => {
      // console.log(res);
      this.worldList = res.data;
    });
    setTimeout(() => {
      this.setMap();
    }, 200);
    this.$get(`${this.$api}/un/webpart/list`, {
      pageNum: 1,
      pageSize: 100,
    }).then((res) => {
      // console.log(res);
      this.memberList1 = [];
      this.memberList2 = [];
      res.data.forEach((item) => {
        if (item.membersType === "1") {
          this.memberList1.push(item);
        } else {
          this.memberList2.push(item);
        }
      });
    });
    setTimeout(() => {
      this.setMap();
    }, 200);
  },
  methods: {
    // 获取会员详情
    handleFullDetail(item) {
      this.$get(`${this.$api}/un/webpart/getInfo`, {
        mpId: item.mpId,
      }).then((res) => {
        this.fullInfo = res.data;
        this.detailVisible = true;
      });
    },
    handleClose() {
      this.detailVisible = false;
    },
    handleMenuClick(name) {
      this.$emit("handleMenuClick", name);
    },
    setMap() {
      this.myChart = echarts.init(document.getElementById("world"));
      echarts.registerMap("world", world);
      this.myChart.setOption({
        top: "1%",
        bottom: "1%",
        // zoom: 2, // 设置当前视角的缩放比例
        scaleLimit: {
          // 限制缩放的比例
          min: 2, // 最小缩放比例
          max: 2, // 最大缩放比例
        },
        visualMap: {
          type: "piecewise",
          show: false,
          pieces: [
            { gt: 40, color: "#FFC94A", label: "未知" },
            { gt: 30, lte: 40, color: "#FF8227", label: "极多" },
            { gt: 20, lte: 30, color: "#00579B", label: "多" },
            { gt: 10, lte: 20, color: "#5AA3FF", label: "中" },
            { gte: 0, lte: 10, color: "#d9e6f4", label: "少" },
          ],
          outOfRange: {
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            // console.log(params);
          },
        },
        series: [
          {
            name: "Members",
            type: "map",
            // 设置当前视角的缩放比例
            zoom: 2,
            map: "world",
            roam: true,
            itemStyle: {
              borderColor: "#aaa", //边界线颜色
              areaColor: "#ebebeb", //默认区域颜色
            },
            emphasis: {
              itemStyle: {
                show: true,
                areaColor: "#fff", //鼠标滑过区域颜色
              },
            },
            data: this.worldList,
          },
        ],
      });

      // 点击事件地图 e.data.name为获取地图的json数据
      // this.myChart.off("click");
      this.myChart.on("click", (e) => {
        // console.log('点击事件地图', e.data.name, e.data.value);
        // this.isShow = true;
        // this.fullInfo
        // handleFullDetail
        let item = this.memberList1.find(
          (member) => member.name === e.data.name
        );
        // console.log(item);
        if (item && item.mpId) {
          this.handleFullDetail(item);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.mobile {
  .page-content {
    display: block !important;
    .world-view {
      .world-title {
        align-items: flex-end !important;
      }
      .world-items .item {
        width: 50% !important;
        margin-bottom: 10px !important;
      }
    }
    .content-menu {
      width: 100% !important;
      position: static !important;
      padding: 16px 0px !important;
      display: inline-flex;
      justify-content: space-between;
      margin: 0 !important;
      border-radius: 6px;
      .menu-item {
        width: 33.33% !important;
        margin-bottom: 0 !important;
        flex: 1;
        position: static !important;
        transform: translate(0) !important;
        padding: 0 10px;
      }
      .item-title {
        font-size: 16px !important;
        line-height: 22px !important;
      }
      .item-icon {
        width: 50px !important;
        height: 50px !important;
        img {
          width: 40px !important;
          height: 40px !important;
        }
      }
    }
  }
}
.full-dialog {
  .detail-title {
    padding: fh(60vh, pc) fw(100vw, pc);
    padding-bottom: 0;
    font-size: fh(36vh, pc);
    line-height: fh(42vh, pc);
    font-weight: bold;
    color: #333333;
  }
  .detail-view {
    padding: fh(30vh, pc) fw(100vw, pc);
    padding-bottom: fh(90vh, pc);
    .detail-item {
      width: 100%;
      display: flex;
      align-items: flex-start;
      font-size: fh(18vh, pc);
      line-height: fh(36vh, pc);
      .label {
        color: #999;
        min-width: 14vw;
        width: max-content;
      }
      .content {
        flex: 1;
      }
    }
  }
}
.page-content {
  width: 100%;
  display: flex;
  padding: fh(60vh, pc) fw(200vw, pc);
  padding-top: 0;
  .content-menu {
    width: fw(240vw, pc);
    background-color: #ececec;
    padding: fh(80vh, pc) fw(20vw, pc);
    margin-left: fw(20vw, pc);
    flex: 1;
    .menu-item {
      width: max-content;
      margin-bottom: fh(40vh, pc);
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      &:hover {
        cursor: pointer;
        .item-title {
          color: #4a92ec;
        }
      }
      .item-icon {
        position: relative;
        background-color: #fff;
        width: fw(90vw, pc);
        height: fw(90vw, pc);
        border-radius: 50%;
        left: 50%;
        transform: translateX(-50%);
        img {
          width: fw(40vw, pc);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .item-title {
        font-weight: bold;
        text-align: center;
        font-size: fh(22vh, pc);
        line-height: fh(36vh, pc);
        color: #333333;
        margin-top: fh(20vh, pc);
      }
    }
  }
  .content-view {
    width: 100%;
    padding-top: fh(60vh, pc);
    .world-view {
      width: 100%;
      .world-title {
        display: flex;
        align-items: center;
        width: 100%;
        font-weight: bold;
        font-size: fh(36vh, pc);
        color: #333333;
        line-height: fh(44vh, pc);
        span {
          font-size: fh(16vh, pc);
          color: #b7b7b7;
          line-height: fh(22vh, pc);
          display: inline-block;
          margin-left: fw(60vw, pc);
          font-weight: 500;
        }
      }
      .sub-title {
        font-weight: bold;
        font-size: fh(24vh, pc);
        color: #333333;
        line-height: fh(30vh, pc);
        margin-top: fh(60vh, pc);
        margin-bottom: fh(40vh, pc);
        &.one {
          margin-top: fh(40vh, pc);
        }
      }
      .world-items {
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .item {
          width: 33.3333%;
          margin-bottom: fh(40vh, pc);
          font-size: fh(24vh, pc);
          color: #2a2a2a;
          line-height: fh(30vh, pc);
          &.full:hover {
            cursor: pointer;
            opacity: 0.8;
          }
        }
      }
    }
  }
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  > img {
    width: 100%;
    display: block;
  }
  .sub-title {
    margin: fh(20vh, pc) 0;
    font-size: fh(24vh, pc);
    line-height: fh(54vh, pc);
    font-weight: bold;
    color: #333333;
  }
  .text {
    // margin-top: fh(55vh, pc);
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(28vh, pc);
  }
  .more-btn {
    margin: fh(50vh, pc) auto;
  }
}
</style>
